export const channels = {
  android: "android",
  corporate: "corporate",
  ios: "ios",
  mweb: "mweb",
  mwebCorp: "mweb-corp",
  southwest: "southwest",
};
